var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPublication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 54.396,
    viewBox: "0 0 50 54.396",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "publication",
    transform: "translate(-140 -52.537)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M165.359,333.2a2.4,2.4,0,1,0,2.4,2.4A2.43,2.43,0,0,0,165.359,333.2Zm0,3.361a1.028,1.028,0,1,1,1.029-1.028A1.055,1.055,0,0,1,165.359,336.561Z",
    transform: "translate(-20.146 -246.292)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M263.359,333.2a2.4,2.4,0,1,0,2.4,2.4A2.43,2.43,0,0,0,263.359,333.2Zm0,3.361a1.028,1.028,0,1,1,1.029-1.028A1.055,1.055,0,0,1,263.359,336.561Z",
    transform: "translate(-106.495 -246.292)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M496.879,333.2a2.4,2.4,0,1,0,2.4,2.4A2.43,2.43,0,0,0,496.879,333.2Zm0,3.361a1.028,1.028,0,1,1,1.029-1.028A1.055,1.055,0,0,1,496.879,336.561Z",
    transform: "translate(-312.16 -246.292)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M379.279,333.2a2.4,2.4,0,1,0,2.4,2.4A2.43,2.43,0,0,0,379.279,333.2Zm0,3.361a1.028,1.028,0,1,1,1.029-1.028A1.055,1.055,0,0,1,379.279,336.561Z",
    transform: "translate(-208.554 -246.292)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M141.509,108.717h7.407c.823,0,1.509-.892,1.509-2.126V57.008c0-1.234-.617-2.126-1.509-2.126h-7.407c-.823,0-1.509.892-1.509,2.126v49.583c0,1.235.686,2.126,1.509,2.126Zm-.137-51.709a1.222,1.222,0,0,1,.206-.754h7.2a1.222,1.222,0,0,1,.206.754v4.183h-7.612Zm0,5.555h7.612v3.018h-7.612Zm0,4.389h7.612V96.716h-7.612Zm0,31.135h7.612V101.1h-7.612Zm0,4.321h7.612v4.115a1.222,1.222,0,0,1-.206.754h-7.2a1.222,1.222,0,0,1-.206-.754Z",
    transform: "translate(0 -2.058)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M239.509,108.717h7.407c.823,0,1.509-.892,1.509-2.126V57.008c0-1.234-.617-2.126-1.509-2.126h-7.407c-.823,0-1.509.892-1.509,2.126v49.583c.068,1.235.686,2.126,1.509,2.126Zm-.068-51.709a1.222,1.222,0,0,1,.206-.754h7.2a1.222,1.222,0,0,1,.206.754v4.183H239.44Zm0,5.555h7.612v3.018H239.44Zm0,4.389h7.612V96.716H239.44Zm0,31.135h7.612V101.1H239.44Zm0,4.321h7.612v4.115a1.222,1.222,0,0,1-.206.754h-7.2a1.222,1.222,0,0,1-.206-.754Z",
    transform: "translate(-86.321 -2.058)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M337.414,105.9l7.338,1.029h.137c.754,0,1.44-.823,1.646-1.92l6.309-44.1v43.617c0,1.234.617,2.126,1.509,2.126h7.407c.823,0,1.509-.892,1.509-2.126V54.949c0-1.234-.617-2.126-1.509-2.126h-7.475a1.45,1.45,0,0,0-1.3,1.1,1.309,1.309,0,0,0-.686-.343l-7.269-1.028a1.351,1.351,0,0,0-1.3.617,3.743,3.743,0,0,0-.549,1.3l-6.926,49.1a1.879,1.879,0,0,0,1.166,2.332ZM354.148,54.95a1.222,1.222,0,0,1,.206-.754h7.2a1.222,1.222,0,0,1,.206.754v4.183h-7.612Zm0,5.555h7.612v3.018h-7.612Zm0,4.389h7.612V94.657h-7.612Zm0,31.135h7.612v3.018h-7.612Zm0,4.321h7.612v4.115a1.222,1.222,0,0,1-.206.754h-7.2a1.222,1.222,0,0,1-.206-.754Zm-9.533-45.674a1.693,1.693,0,0,1,.274-.754l7.132,1.028a1.2,1.2,0,0,1,.068.823l-.617,4.183-7.544-1.1Zm-.823,5.486,7.544,1.1-.412,2.949-7.544-1.1Zm-.617,4.32,7.544,1.1L346.536,95l-7.544-1.1Zm-4.389,30.861,7.544,1.1-.411,2.949-7.544-1.1Zm-1.166,8.367.617-4.115,7.544,1.1-.617,4.115a1.693,1.693,0,0,1-.274.754l-7.132-1.028c-.138-.069-.207-.411-.138-.823Z",
    transform: "translate(-173.269)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublication);
export default __webpack_public_path__ + "static/media/publication.986330e67d348626b6ce1afc16d4ac93.svg";
export { ForwardRef as ReactComponent };